import { useScreen, useGrid } from 'vue-screen';

export const screen = useScreen();
export const grid = useGrid({
  xs: useCssVar('--breakpoint-xs')?.value,
  sm: useCssVar('--breakpoint-sm')?.value,
  md: useCssVar('--breakpoint-md')?.value,
  lg: useCssVar('--breakpoint-lg')?.value,
  xl: useCssVar('--breakpoint-xl')?.value,
  '2xl': useCssVar('--breakpoint-2xl')?.value,
  '3xl': useCssVar('--breakpoint-3xl')?.value,
});
